import React from 'react';
import { motion } from 'framer-motion';
import patienteImage from '../img/Patiente souriante et clinicienne.png';

const TherapeuticsSection = () => {
  return (
    <section id="therapeutics" className="py-20 md:py-32 relative bg-ninsun-surface border-y border-gray-200">
      <div className="container mx-auto px-6">

        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-ninsun-text mb-6 tracking-tight">NinStem Lung in Drug Development</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-12"
          >
            <div>
              <h3 className="text-3xl font-display font-bold text-ninsun-text mb-4 tracking-tight">
                Increasing probability of clinical trials success
              </h3>
              <p className="text-ninsun-muted leading-relaxed mb-4">
                The NinStem Lung Test Kit helps biopharmaceutical companies reduce clinical trial risk by improving patient selection and enriching study cohorts with patients more likely to respond to therapy.
              </p>
              <p className="text-ninsun-text font-bold">
                <a href="mailto:contact@ninsun-biotech.com" className="text-ninsun-gold hover:underline">Contact us</a> to learn more how our technology can benefit to the development of your immunotherapies.
              </p>
            </div>

            <div>
              <h3 className="text-3xl font-display font-bold text-ninsun-text mb-4 tracking-tight">
                Exploring new therapeutic routes
              </h3>
              <p className="text-ninsun-muted leading-relaxed mb-4">
                The specificity of Ninsun Biotech’s technology in identifying Cancer Stem Cells could make it suitable for use in targeted therapies, a potentially formidable therapeutic opportunity for patients left without therapeutic options.
              </p>
              <p className="text-ninsun-muted leading-relaxed mb-4">
                Pre-clinical in vitro proof-of-concept studies are being conducted with lectin-based drug conjugate in partnership with HES-SO Valais-Wallis and funded by Innosuisse.
              </p>
              <p className="text-ninsun-text font-bold">
                <a href="mailto:contact@ninsun-biotech.com" className="text-ninsun-gold hover:underline">Contact us</a> to be regularly informed of our progress.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <img 
              src={patienteImage}
              alt="Patient and clinician smiling"
              className="rounded-2xl shadow-lg w-full h-auto border border-gray-200"
            />
          </motion.div>
        </div>

      </div>
    </section>
  );
};

export default TherapeuticsSection;